module.exports = __webpack_public_path__ + "static/media/baked-pizza.39881080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/baked-pizza.jpg
// module id = 26
// module chunks = 0